// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HeroSearchController from "./hero_search_controller"
application.register("hero-search", HeroSearchController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ProfileModalController from "./profile_modal_controller"
application.register("profile-modal", ProfileModalController)

import ReviewsModalController from "./reviews_modal_controller"
application.register("reviews-modal", ReviewsModalController)

import CalendarModalController from "./calendar_modal_controller"
application.register("calendar-modal", CalendarModalController)

import CalendarSwipeController from "./calendar_swipe_controller"
application.register("calendar-swipe", CalendarSwipeController)

import ServiceCalendarPairController from "./service_calendar_pair_controller"
application.register("service-calendar-pair", ServiceCalendarPairController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CitySelectorController from "./city_selector_controller"
application.register("city-selector", CitySelectorController)

import ConstructionNoticeController from "./construction_notice_controller"
application.register("construction-notice", ConstructionNoticeController)

import HighlightPlayerController from "./highlight_player_controller"
application.register("reels-viewer", HighlightPlayerController)

import HighlightReelController from "./highlight_reel_controller"
application.register("highlight-reel", HighlightReelController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ScheduleManagerController from "./schedule_manager_controller"
application.register("schedule-manager", ScheduleManagerController)

import FeaturedCityPickerController from "./featured_city_picker_controller"
application.register("featured-city-picker", FeaturedCityPickerController)

import GeolocationController from "./geolocation_controller"
application.register("geolocation", GeolocationController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LocationPickerController from "./location_picker_controller"
application.register("location-picker", LocationPickerController)

import LocationToggleController from "./location_toggle_controller"
application.register("location-toggle", LocationToggleController)

import MapDisplayController from "./map_display_controller"
application.register("map-display", MapDisplayController)

import MessageController from "./message_controller"
application.register("message", MessageController)

import NavbarScrollController from "./navbar_scroll_controller"
application.register("navbar-scroll", NavbarScrollController)

import ProfileStickyBarController from "./profile_sticky_bar_controller"
application.register("profile-sticky-bar", ProfileStickyBarController)

import HomeHeroNavController from "./home_hero_nav_controller"
application.register("home-hero-nav", HomeHeroNavController)

import NotificationsDropdownController from "./notifications_dropdown_controller"
application.register("notifications-dropdown", NotificationsDropdownController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import RoleSelectorController from "./role_selector_controller"
application.register("role-selector", RoleSelectorController)

import ScrollContainerController from "./scroll_container_controller"
application.register("scroll-container", ScrollContainerController)

import SwipeNavigationController from "./swipe_navigation_controller"
application.register("swipe-navigation", SwipeNavigationController)

import TranslationModalController from "./translation_modal_controller"
application.register("translation-modal", TranslationModalController)

import VerificationPreviewController from "./verification_preview_controller"
application.register("verification-preview", VerificationPreviewController)

import VideoHoverController from "./video_hover_controller"
application.register("video-hover", VideoHoverController)

import VideoPreviewController from "./video_preview_controller"
application.register("video-preview", VideoPreviewController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import SkeletonLoaderController from "./skeleton_loader_controller"
application.register("skeleton-loader", SkeletonLoaderController)

import TermsGuardController from "./terms_guard_controller"
application.register("terms-guard", TermsGuardController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import ClassesBrowseSortController from "./classes_browse_sort_controller"
application.register("classes-browse-sort", ClassesBrowseSortController)

import ClassesBrowseFiltersController from "./classes_browse_filters_controller"
application.register("classes-browse-filters", ClassesBrowseFiltersController)

import BrowseSchedulePickerController from "./browse_schedule_picker_controller"
application.register("browse-schedule-picker", BrowseSchedulePickerController)

import SpecializationPickerController from "./specialization_picker_controller"
application.register("specialization-picker", SpecializationPickerController)

import SpecializationFilterController from "./specialization_filter_controller"
application.register("specialization-filter", SpecializationFilterController)

import PushNotificationsController from "./push_notifications_controller"
application.register("push-notifications", PushNotificationsController)

import NotificationSettingsController from "./notification_settings_controller"
application.register("notification-settings", NotificationSettingsController)

import CookieBannerController from "./cookie_banner_controller"
application.register("cookie-banner", CookieBannerController)

import ReviewDisputeController from "./review_dispute_controller"
application.register("review-dispute", ReviewDisputeController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import DashboardTabsController from "./dashboard_tabs_controller"
application.register("dashboard-tabs", DashboardTabsController)

import WorkoutBuilderController from "./workout_builder_controller"
application.register("workout-builder", WorkoutBuilderController)

import WorkoutModalController from "./workout_modal_controller"
application.register("workout-modal", WorkoutModalController)

import RichTextController from "./rich_text_controller"
application.register("rich-text", RichTextController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)

import ImageManagementController from "./image_management_controller"
application.register("image-management", ImageManagementController)

import MultiSelectDropdownController from "./multi_select_dropdown_controller"
application.register("multi-select-dropdown", MultiSelectDropdownController)

import ReportModalController from "./report_modal_controller"
application.register("report-modal", ReportModalController)

import ClientHistoryModalsController from "./client_history_modals_controller"
application.register("client-history-modals", ClientHistoryModalsController)

import WorkoutAssignModalController from "./workout_assign_modal_controller"
application.register("workout-assign-modal", WorkoutAssignModalController)

import QrScannerController from "./qr_scanner_controller"
application.register("qr-scanner", QrScannerController)

import CheckInController from "./check_in_controller"
application.register("check-in", CheckInController)

import ScrollToBottomController from "./scroll_to_bottom_controller"
application.register("scroll-to-bottom", ScrollToBottomController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import AttendeesModalController from "./attendees_modal_controller"
application.register("attendees-modal", AttendeesModalController)

import AnchoredTooltipController from "./anchored_tooltip_controller"
application.register("anchored-tooltip", AnchoredTooltipController)

import PaymentStatusController from "./payment_status_controller"
application.register("payment-status", PaymentStatusController)
